import React, { Component } from 'react';

import { TextField } from 'react-md';

export default class GroupManageView extends Component {

    constructor(props) {
        super(props);

        this.state = {

        }

        this.selectMyLocation = this.selectMyLocation.bind(this);
        this.selectAllLocations = this.selectAllLocations.bind(this);
        this.selectClientAccountLocations = this.selectClientAccountLocations.bind(this);
        this.getClientAccountStatus = this.getClientAccountStatus.bind(this);
        this.deleteYourLocation = this.deleteYourLocation.bind(this);

        this.generateMyLocations = this.generateMyLocations.bind(this);
        this.generateYourLocations = this.generateYourLocations.bind(this);
    }

    selectMyLocation(locationId) {
        let myLocationMembers = this.props.currentTab === 'manage' ? this.props.groupForm.myLocationMembers : this.props.youGroupForm.myLocationMembers;
        if (myLocationMembers.includes(locationId)) {
            myLocationMembers.splice(myLocationMembers.indexOf(locationId), 1);
        } else {
            myLocationMembers.push(locationId);
        }

        if (this.props.currentTab === 'manage') {
            this.props.editGroupForm("myLocationMembers", myLocationMembers);
        } else {
            this.props.editYouGroupForm("myLocationMembers", myLocationMembers);
        }
    }

    selectAllLocations(isDeselect) {
        if (this.props.currentTab === 'manage') {
            this.props.editGroupForm("myLocationMembers", (isDeselect ? [] : Object.keys(this.props.locationMap)));
        } else {
            this.props.editYouGroupForm("myLocationMembers", (isDeselect ? [] : Object.keys(this.props.locationMap)));
        }
    }

    selectClientAccountLocations(locationList) {
        let myLocationMembers = this.props.currentTab === 'manage' ? this.props.groupForm.myLocationMembers : this.props.youGroupForm.myLocationMembers;

        let tmpMembers = [];
        let tmpLocs = locationList.map(x => x.id);
        let isAdding = true;
        for (var i = 0; i < myLocationMembers.length; i++) {
            if (tmpLocs.includes(myLocationMembers[i])) {
                isAdding = false;
            } else {
                tmpMembers.push(myLocationMembers[i]);
            }
        }
        if (isAdding) {
            tmpLocs.forEach(mem => {
                tmpMembers.push(mem);
            });
        }

        if (this.props.currentTab === 'manage') {
            this.props.editGroupForm("myLocationMembers", tmpMembers);
        } else {
            this.props.editYouGroupForm("myLocationMembers", tmpMembers);
        }
    }

    getClientAccountStatus(locations) {
        let status = 0;
        let myLocationMembers = this.props.currentTab === 'manage' ? this.props.groupForm.myLocationMembers : this.props.youGroupForm.myLocationMembers;
        let tmpLocs = locations.map(x => x.id);

        let activeCount = 0;
        myLocationMembers.forEach(locMem => {
            if (tmpLocs.includes(locMem)) {
                activeCount++;
                status = 1;
            }
        });

        if (activeCount === tmpLocs.length) {
            status = 2;
        }

        return status;
    }

    deleteYourLocation(memberName, memberIdList) {
        this.props.deleteGroupMember(this.props.groupForm.name, memberName, memberIdList)
    }

    generateMyLocations() {
        let result = [];

        let myLocationMembers = this.props.currentTab === 'manage' ? this.props.groupForm.myLocationMembers : this.props.youGroupForm.myLocationMembers;

        if (this.props.groupModeIndex === 0) {

            let locObjs = _.sortBy(Object.keys(this.props.locationMap).reduce((r, e) => {
                r.push({
                    id: e,
                    name: this.props.locationMap[e]
                })
                return r;
            }, []), x => x.name);

            let isMulti = locObjs.length > 1;


            if (isMulti) {
                let isDeselect = locObjs.length === myLocationMembers.length;
                result.push((
                    <div className={"location-outer"} onClick={this.selectAllLocations.bind(null, isDeselect)}>
                        <div className={"material-icons location-checker"}>
                            <div className={"location-shader" + (isDeselect ? " active" : myLocationMembers.length > 0 ? " half" : "")}></div>
                            <div className={"material-icons location-icon"}>{"location_city"}</div>
                        </div>
                        <div className={"location-name"}>{(isDeselect ? "Deselect" : "Select") + " All"}</div>
                    </div>
                ));
            }

            locObjs.forEach(loc => {
                let isActive = myLocationMembers.includes(loc.id);
                result.push((
                    <div className={"location-outer" + (isActive ? " active" : "") + (isMulti ? " spaced" : "")} onClick={this.selectMyLocation.bind(null, loc.id)}>
                        <div className={"location-checker"}>
                            <div className={"location-shader" + (isActive ? " active" : "")}></div>
                            <div className={"material-icons location-icon"}>{"location_on"}</div>
                        </div>
                        <div className={"location-name"}>{loc.name}</div>
                    </div>
                ))
            });
        } else if (this.props.groupModeIndex === 1) {
            let self = this;

            this.props.locationMap.forEach(ca => {

                let caSelectionStatus = this.getClientAccountStatus(ca.locations);

                result.push((
                    <div className={"location-outer"}>
                        <div className={"material-icons location-checker"} onClick={this.selectClientAccountLocations.bind(null, ca.locations)}>
                            <div className={"location-shader" + (caSelectionStatus === 2 ? " active" : caSelectionStatus === 1 ? " half" : "")}></div>
                            <div className={"material-icons location-icon"}>{"location_city"}</div>
                        </div>
                        <div className={"location-name"} onClick={this.props.setExpandedClientAccount.bind(null, ca.id)}>{ca.name}</div>
                    </div>
                ));

                if (this.props.expandedClientAccount === ca.id) {
                    ca.locations.forEach(loc => {
                        let isActive = myLocationMembers.includes(loc.id);
                        result.push((
                            <div className={"location-outer" + (isActive ? " active" : "") + " spaced"} onClick={this.selectMyLocation.bind(null, loc.id)}>
                                <div className={"location-checker"}>
                                    <div className={"location-shader" + (isActive ? " active" : "")}></div>
                                    <div className={"material-icons location-icon"}>{"location_on"}</div>
                                </div>
                                <div className={"location-name"}>{loc.name}</div>
                            </div>
                        ))
                    });
                }
            });
        }

        return result;
    }

    generateYourLocations() {
        let result = [];

        let ylm = this.props.groupForm.yourLocationMembers;
        let organizedYlm = ylm.reduce((r, e) => {
            let key = e.clientAccountName;
            if (!r[key]) {
                r[key] = [];
            }

            r[key].push({ groupMemberId: e.groupMemberId, locationName: e.locationName });

            return r;
        }, {});

        let ylmKeys = _.sortBy(Object.keys(organizedYlm), x => x);
        ylmKeys.forEach(key => {
            let allDelActive = this.props.deleteMemberId + "loc" === key + "loc";
            result.push((
                <div className={"location-outer"}>
                    <div className={"material-icons location-checker alt-color"} onClick={this.props.setDeleteMemberId.bind(null, key)}>
                        <div className={"material-icons location-icon"}>{"location_city"}</div>
                    </div>
                    <div className={"location-name" + (allDelActive ? " delmode" : "")} onClick={this.props.setDeleteMemberId.bind(null, key)}>{key}</div>
                    <div className={"material-icons deleter" + (allDelActive ? " delmode" : "")} onClick={this.deleteYourLocation.bind(null, key, organizedYlm[key].map(x => x.groupMemberId))}>{"delete"}</div>
                </div>
            ));

            _.sortBy(organizedYlm[key], x => x.locationName).forEach(loc => {

                let delActive = this.props.deleteMemberId === loc.groupMemberId;
                result.push((
                    <div className={"location-outer spaced"}>
                        <div className={"location-checker alt-color"} onClick={this.props.setDeleteMemberId.bind(null, loc.groupMemberId)}>
                            <div className={"material-icons location-icon"}>{"location_on"}</div>
                        </div>
                        <div className={"location-name" + (delActive ? " delmode" : "")} onClick={this.props.setDeleteMemberId.bind(null, loc.groupMemberId)}>{loc.locationName}</div>
                        <div className={"material-icons deleter" + (delActive ? " delmode" : "")} onClick={this.deleteYourLocation.bind(null, loc.locationName, [loc.groupMemberId])}>{"delete"}</div>
                    </div>
                ))
            });
        });

        return result;
    }

    generateViewers() {
        let result = [];

        let vm = this.props.groupForm.viewerMembers;
        let organizedVm = vm.reduce((r, e) => {
            let key = e.clientAccountName;
            if (!r[key]) {
                r[key] = [];
            }

            r[key].push({ groupMemberId: e.groupMemberId, name: (e.firstName + " " + e.lastName) });

            return r;
        }, {});

        let vmKeys = _.sortBy(Object.keys(organizedVm), x => x);
        vmKeys.forEach(key => {
            let allDelActive = this.props.deleteMemberId + "usr" === key + "usr";
            result.push((
                <div className={"location-outer"}>
                    <div className={"material-icons location-checker alt-color"} onClick={this.props.setDeleteMemberId.bind(null, key)}>
                        <div className={"material-icons location-icon"}>{"location_city"}</div>
                    </div>
                    <div className={"location-name" + (allDelActive ? " delmode" : "")} onClick={this.props.setDeleteMemberId.bind(null, key)}>{key}</div>
                    <div className={"material-icons deleter" + (allDelActive ? " delmode" : "")} onClick={this.deleteYourLocation.bind(null, key, organizedVm[key].map(x => x.groupMemberId))}>{"delete"}</div>
                </div>
            ));

            _.sortBy(organizedVm[key], x => x.name).forEach(usr => {

                let delActive = this.props.deleteMemberId === usr.groupMemberId;
                result.push((
                    <div className={"location-outer spaced"}>
                        <div className={"location-checker alt-color"} onClick={this.props.setDeleteMemberId.bind(null, usr.groupMemberId)}>
                            <div className={"material-icons location-icon"}>{"location_on"}</div>
                        </div>
                        <div className={"location-name" + (delActive ? " delmode" : "")} onClick={this.props.setDeleteMemberId.bind(null, usr.groupMemberId)}>{usr.name}</div>
                        <div className={"material-icons deleter" + (delActive ? " delmode" : "")} onClick={this.deleteYourLocation.bind(null, usr.name, [usr.groupMemberId])}>{"delete"}</div>
                    </div>
                ))
            });
        });

        return result;
    }

    render() {

        let myLocationsJsx = this.generateMyLocations();
        let yourLocationsJsx = this.props.currentTab === "manage" ? this.generateYourLocations() : [];
        let viewersJsx = this.props.currentTab === "manage" ? this.generateViewers() : [];

        return (
            <div className={"stackup-group-manage-outer" + (this.props.isActive ? "" : " hidden")}>
                <div className={"card-container"}>
                    <div className={"label"}>{"Group Name"}</div>
                    {this.props.currentTab === 'manage' ?
                        <TextField
                            id="group-name-textfield"
                            placeholder={"My New Group"}
                            className={"group-text-input"}
                            value={this.props.groupForm.name}
                            onChange={this.props.editGroupForm.bind(null, "name")}
                        />
                        :
                        <div>{this.props.youGroupForm.name}</div>
                    }
                    <div className={"label"}>{"Group Description"}</div>
                    {this.props.currentTab === 'manage' ?
                        <TextField
                            id="group-description-textfield"
                            placeholder={"A Group of Heavy Hitters"}
                            className={"group-text-input"}
                            value={this.props.groupForm.description}
                            onChange={this.props.editGroupForm.bind(null, "description")}
                        />
                        :
                        <div>{this.props.youGroupForm.description}</div>
                    }
                    {this.props.currentTab === 'manage' ?
                        <div className={"binary-selection-container"}>
                            <div className={"selection" + (this.props.groupForm.isPublic ? " active" : "")} onClick={this.props.editGroupForm.bind(null, "isPublic", true)}>{"Public"}</div>
                            <div className={"selection" + (!this.props.groupForm.isPublic ? " active" : "")} onClick={this.props.editGroupForm.bind(null, "isPublic", false)}>{"Private"}</div>
                        </div>
                        : null
                    }
                    <div className={"label"} onClick={this.props.setMinimizer.bind(null, "myLoc")}><span className={"material-icons drop-icon" + (this.props.minimizer.myLoc ? " min" : "")}>{"arrow_forward_ios"}</span>{"My Locations"}</div>
                    <div className={"locations-container"} style={{ height: (this.props.minimizer.myLoc ? "0rem" : ((myLocationsJsx.length * 2) + "rem")) }}>{myLocationsJsx}</div>
                </div>
                {this.props.isNew || this.props.currentTab != "manage" || this.props.groupForm.yourLocationMembers.length === 0 ? null :
                    <div className={"card-container"}>
                        <div className={"label"} onClick={this.props.setMinimizer.bind(null, "youLoc")}><span className={"material-icons drop-icon" + (this.props.minimizer.youLoc ? " min" : "")}>{"arrow_forward_ios"}</span>{"Member Locations"}</div>
                        <div className={"locations-container"} style={{ height: (this.props.minimizer.youLoc ? "0rem" : ((yourLocationsJsx.length * 2) + "rem")) }}>{yourLocationsJsx}</div>
                    </div>
                }
                {this.props.isNew || this.props.currentTab != "manage" || this.props.groupForm.viewerMembers.length === 0 ? null :
                    <div className={"card-container"}>
                        <div className={"label"} onClick={this.props.setMinimizer.bind(null, "viewers")}><span className={"material-icons drop-icon" + (this.props.minimizer.viewers ? " min" : "")}>{"arrow_forward_ios"}</span>{"Viewers"}</div>
                        {this.props.groupModeIndex != 1 ? null : (
                            <div className={"add-self"} onClick={this.props.submitScanCodeManual}>{"Add Myself as Viewer"}</div>
                        )}
                        <div className={"locations-container"} style={{ height: (this.props.minimizer.viewers ? "0rem" : ((viewersJsx.length * 2) + "rem")) }}>{viewersJsx}</div>
                    </div>
                }
            </div>
        );
    }
}

